export const ENABLE_CREDIT = 1 //开启信用额度
export const DISABLE_CREDIT = 0 //关闭信用额度